<template>
  <div>
    <div>
      <b-modal
        id="modal-prevent-closing"
        ref="my-modal"
        title="Configurações da resposta do usuário"
        centered
        ok-title="Salvar"
        cancel-variant="outline-secondary"
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleOk"
      >
        <form
          ref="form"
          @submit.stop.prevent="handleSubmit"
        >
          <b-form-group
            :state="nameState"
            label="Nome do Campo:"
            label-for="name-input"
            invalid-feedback="Name is required"
          >

            <b-form-input
              id="name-input"
              v-model="name"
              :state="nameState"
              required
            />
          </b-form-group>
        </form>
      </b-modal>
    </div>
    <div v-if="dadoschat && dadoschat.length" class="card">
      <div class="input-group mb-3 ">
        <span
          id="basic-addon1"
          class="input-group-text btn-success"
        >Iniciar</span>
        <Info
          :variaveis="variaveis"
          :message="dadoschat[0].callToAction"
          @atualizarMessage="atualizarCallAction($event)"
        />
      </div>
      <div
        v-for="(mensagem, index) in inicial"
        :key="mensagem.sequencia"
        class="mensagem"
      >
        <div
          v-show="selectedIdini === mensagem.id"
          class="drop-area"
        >
          <span class="drop-text">Solte aqui</span>
        </div>
        <div
          class="card"
          draggable="true"
          @dragstart="selectedIdini = mensagem.id;dragStart(index, 'inicial')"
          @dragover="dragOver(index, 'inicial')"
          @dragend="dragEnd(index, 'inicial');selectedIdini = null"
          @mouseover="showDropArea = true"
          @mouseout="showDropArea = false"
        >
          <div
            id="input-messagem-fluxo-messagem"
            class="input-group my-2"
          >
            <span
              id="basic-addon1"
              data-tourTarget="input-messagem-fluxo-messagem"
              class="input-group-text"
              style="border: none !important;"
            >
              <feather-icon
                icon="MoveIcon"
                size="18"
                stroke="currentColor"
                class="mr-50 mover"
              />
            </span>
            <span
              id="basic-addon1"
              class="input-group-text dk-badge-msg"
            >Mensagem</span>
            <Info
              :id="mensagem.id"
              :variaveis="variaveis"
              :message="mensagem.message"
              @atualizarMessage="atualizarMessageFluxo($event, {
                id: mensagem.id,
                sequencia: mensagem.sequencia,
                nomeArray: 'inicial'
              })"
            />
            <b-button
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              v-b-modal.modal-delete-fluxo-chat
              v-b-tooltip.hover.v-dark
              data-tourTarget="btn-remover-fluxo-messagem"
              style="height: 38px;"
              title="Remover"
              variant="outline-dark"
            >
              <feather-icon
                icon="TrashIcon"
                size="18"
                stroke="currentColor"
                class="mr-50"
                @click="formDeleteModal = JSON.parse(JSON.stringify({
                  index: index,
                  nameArray: 'inicial',
                  dataMessage: mensagem,
                }))"
              />
            </b-button>
          </div>
          <input
            v-model="mensagem.sequencia"
            type="number"
            style="border: none;"
            hidden
            @change="ordenarMensagens('inicial')"
          >
        </div>
      </div>
      <div />
      <b-dropdown
        id="dropdpwn_inicial"
        data-tourTarget="options-chamada-inicial-fluxo-messagem"
        text="Adicionar Bloco"
        variant="outline-secondary"
        style="width: max-content;margin-left: auto;"
      >
        <b-dropdown-item id="options-message-bot-message-fluxo" @click="adicionarMensagem('inicial', '0')">
          Mensagem do Bot
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <div
      class="card"
      style="background: none;border: none;"
    >

      <div
        v-for="(mensagem, index) in fluxo"
        :key="mensagem.sequencia"
        class="mensagem"
      >

        <div
          v-show="showDropArea && selectedId === mensagem.id"
          class="drop-area"
        >
          <span class="drop-text">Solte aqui</span>
        </div>

        <div
          :id="mensagem.id"
          class="card"
          draggable="true"
          @dragstart="selectedId = mensagem.id; dragStart(index, 'fluxo')"
          @dragover="dragOver(index, 'fluxo')"
          @dragend="dragEnd(index, 'fluxo'); selectedId = null"
          @mouseover="showDropArea = true"
          @mouseout="showDropArea = false"
        >
          <div
            class="input-group my-2"
            :class="{ dragging: selectedId === mensagem.id }"
          >
            <span
              id="basic-addon1"
              style="border: none !important;"
              class="input-group-text"
            >
              <feather-icon
                icon="MoveIcon"
                size="18"
                stroke="currentColor"
                class="mr-50 mover"
              />
            </span>
            <span
              v-if="mensagem.type === 0 "
              id="basic-addon1"
              class="input-group-text dk-badge-msg"
            >Mensagem</span>
            <span
              v-if="mensagem.type === 1"
              id="basic-addon1"
              v-b-modal.modal-type-response-chat
              :class="{ 'btn-success': mensagem.type === 1 }"
              class="input-group-text dk-badge-msg"
              @click="isCampoRequired = mensagem"
            >

              {{ mensagem.type === 1 ? mensagem.label : 'Mensagem' }}
            </span>
            <span
              v-if="mensagem.type === 2 || mensagem.type === 3 "
              id="basic-addon1"
              v-b-modal.modal-type-response-chat
              class="input-group-text btn-success dk-badge-msg"
              @click="isCampoRequired = mensagem"
            >
              {{ mensagem.type === 2 || mensagem.type === 3 ? mensagem.label : 'Mensagem' }}
            </span>
            <Info
              v-if="mensagem.type === 0 || mensagem.type === 3"
              :id="mensagem.id"
              :variaveis="variaveis"
              :message="mensagem.message"
              @atualizarVariaveis="updateArrayVariaveis($event)"
              @atualizarMessage="atualizarMessageFluxo($event, {
                id: mensagem.id,
                sequencia: mensagem.sequencia,
                nomeArray: 'fluxo'
              })"
            />

            <select
              v-if="mensagem.type === 1"
              id="fruit"
              v-model="mensagem.id_type"
              class="form-control"
              @change="atualizaIdtype(mensagem);"
            >
              <option
                v-for="tipo in typesMensagem"
                :key="tipo.id"
                :value="tipo.id"
              >{{ tipo.idField }}
              </option>
            </select>
            <b-form-tags
              v-if="mensagem.type === 2"
              v-model="mensagem.tags"
              input-id="tags-basic"
              label="name"
              @input="atualizaOpcao(mensagem)"
            />
            <b-button
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              v-b-tooltip.hover.v-dark
              v-b-modal.modal-delete-fluxo-chat
              :style="{ height: mensagem.type !== 2 ? '38px' : 'auto' }"
              title="Remover"
              variant="outline-dark"
              @click="formDeleteModal = JSON.parse(JSON.stringify({
                index: index,
                nameArray: 'fluxo',
                dataMessage: mensagem,
              }))"
            >
              <feather-icon
                icon="TrashIcon"
                size="18"
                stroke="currentColor"
                class="mr-50"
              />
            </b-button>
            <input
              v-model="mensagem.sequencia"
              type="number"
              style="border: none;"
              hidden
              @change="ordenarMensagens('fluxo')"
            >
          </div>
          <div
            v-if="mensagem.type === 2 && mensagem.whatsApp === 1"
            class="mt-2"
            style="margin-left: 51px;"
          >
            <div
              v-for="item in mensagem.options"
              :key="item.name"
              class="input-wrapper"
            >
              <b-form-group
                :label="item.name"
                label-for="phone"
                style="
                    display: flex;
                    align-items: center;
                    gap: 20px;
                "
              >
                <b-input-group>
                  <b-input-group-prepend is-text>
                    BR (+55)
                  </b-input-group-prepend>
                  <cleave
                    id="phone"
                    v-model="item.whatsApp"
                    class="form-control"
                    :raw="false"
                    :options="{
                      phone: true,
                      phoneRegionCode: 'BR',
                    }"
                    placeholder="+55 11 918185353"
                  />
                </b-input-group>

              </b-form-group>
            </div>
          </div>
          <div
            v-if="mensagem.type === 3"
            class="mt-2"
            style="margin-left: 51px;"
          >
            <div class="input-wrapper">
              <div class="row align-items-center">
                <div class="col-auto">
                  <h5><strong>Horário de atendimento</strong></h5>
                </div>
                <div class="col-auto">
                  <b-form-checkbox
                    v-model="mensagem.horario_whatsApp"
                    :checked="mensagem.horario_whatsApp"
                    value="1"
                    unchecked-value="0"
                    type="checkbox"
                    class="custom-control-success"
                    name="check-button"
                    switch
                  />
                </div>
              </div>
            </div>
            <div v-if="mensagem.horario_whatsApp === 1 || mensagem.horario_whatsApp === '1'">
              <div class="input-wrapper mt-2">
                <label><strong>Intervalo de horas</strong></label>
                <div class="row align-items-center">
                  <div class="col-auto">
                    <input
                      v-model="mensagem.horas_inicio_whatsApp"
                      type="time"
                      class="form-control"
                    >
                  </div>
                  <div class="col-auto">
                    <span class="mx-1">até</span>
                  </div>
                  <div class="col-auto">
                    <input
                      v-model="mensagem.horas_finais_whatsApp"
                      type="time"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
              <div class="input-wrapper mt-2">
                <label><strong>Dias da semana</strong></label>
                <div class="row alou">
                  <div class="form-check">

                    <b-form-checkbox
                      v-model="mensagem.seg_whatsApp"
                      :checked="mensagem.seg_whatsApp"
                      value="1"
                      unchecked-value="0"
                      type="checkbox"
                      class="custom-control-success"
                      name="check-button"
                    />
                    <label
                      class="form-check-label"
                      for="segunda"
                    >Seg</label>
                  </div>
                  <div class="form-check">
                    <b-form-checkbox
                      v-model="mensagem.ter_whatsApp"
                      :checked="mensagem.ter_whatsApp"
                      value="1"
                      unchecked-value="0"
                      type="checkbox"
                      class="custom-control-success"
                      name="check-button"
                    />
                    <label
                      class="form-check-label"
                      for="terca"
                    >Ter</label>
                  </div>
                  <div class="form-check">
                    <b-form-checkbox
                      v-model="mensagem.qua_whatsApp"
                      :checked="mensagem.qua_whatsApp"
                      value="1"
                      unchecked-value="0"
                      type="checkbox"
                      class="custom-control-success"
                      name="check-button"
                    />
                    <label
                      class="form-check-label"
                      for="quarta"
                    >Qua</label>
                  </div>
                  <div class="form-check">
                    <b-form-checkbox
                      v-model="mensagem.qui_whatsApp"
                      :checked="mensagem.qui_whatsApp"
                      value="1"
                      unchecked-value="0"
                      type="checkbox"
                      class="custom-control-success"
                      name="check-button"
                    />
                    <label
                      class="form-check-label"
                      for="quinta"
                    >Qui</label>
                  </div>
                  <div class="form-check">
                    <b-form-checkbox
                      v-model="mensagem.sex_whatsApp"
                      :checked="mensagem.sex_whatsApp"
                      value="1"
                      unchecked-value="0"
                      type="checkbox"
                      class="custom-control-success"
                      name="check-button"
                    />
                    <label
                      class="form-check-label"
                      for="sexta"
                    >Sex</label>
                  </div>
                  <div class="form-check">
                    <b-form-checkbox
                      v-model="mensagem.sab_whatsApp"
                      :checked="mensagem.sab_whatsApp"
                      value="1"
                      unchecked-value="0"
                      type="checkbox"
                      class="custom-control-success"
                      name="check-button"
                    />
                    <label
                      class="form-check-label"
                      for="sabado"
                    >Sáb</label>
                  </div>
                  <div class="form-check">
                    <b-form-checkbox
                      v-model="mensagem.dom_whatsApp"
                      :checked="mensagem.dom_whatsApp"
                      value="1"
                      unchecked-value="0"
                      type="checkbox"
                      class="custom-control-success"
                      name="check-button"
                    />
                    <label
                      class="form-check-label"
                      for="domingo"
                    >Dom</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="input-wrapper mt-2">
              <label for="title2"><strong>Mensagem Enviada no WhatsApp:</strong></label>
              <input
                v-model="mensagem.mensagem_whatsApp"
                type="text"
              >
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="d-flex justify-content-center mb-2">
      <b-dropdown
        id="dropdpwn_fluxo"
        data-tourTarget="btn-dropdown-add-bloco-fluxo-messagem"
        text="Adicionar Bloco"
        variant="outline-secondary"
      >
        <b-dropdown-item @click="adicionarMensagem('fluxo', '0')">Mensagem do Bot</b-dropdown-item>
        <b-dropdown-item @click="adicionarMensagem('fluxo', '1')">Resposta do Usuario</b-dropdown-item>
        <b-dropdown-item @click="adicionarMensagem('fluxo', '2')">Lista de Opções</b-dropdown-item>
        <b-dropdown-item @click="adicionarMensagem('fluxo', '3')">Redirecionar para WhatsApp</b-dropdown-item>
      </b-dropdown>
    </div>
    <div v-if="inteligente && inteligente.length" class="card">
      <h2>Chamadas Inteligentes</h2>
      <div class="">
        <div
          style="margin-top: 27px;"
          data-tourTarget="chamada-inteligente-fluxo-message"
        >
          <b-form-group label="Chamada Inteligente:">
            <b-form-radio-group
              v-model="inteligente[0].status"
              :options="[{ text: 'Ativada', value: 1 }, { text: 'Pausada', value: 0 }]"
              @change="editarChamada()"
            />
          </b-form-group>
        </div>

        <div
          data-tourTarget="tempo-variar-chamada-fluxo-message"
          class="md-1"
          style="margin-top: 27px;"
        >
          <span>
            Tempo para variar a chamada: {{ inteligente[0].time }}s
          </span>
          <input
            id="customRange"
            v-model="inteligente[0].time"
            type="range"
            class="form-range"
            value="0"
            name="points"
            inline
            min="20"
            max="60"
          >
        </div>
        <div

          class="md-1"
          style="margin-top: 19px;display: grid;"
        >
          <span
            class="ant-typography ant-typography-ellipsis ant-typography-single-line ant-typography-ellipsis-single-line colorText___Jqdck"
          >
            Título da sua chamada inteligente:
          </span>

          <div
            class="input-group my-2"
            data-tourTarget="titulo-chamada-inteligente-fluxo-message"
          >
            <Info
              :id="inteligente[0].id"
              :variaveis="variaveis"
              :message="inteligente[0].titulo_inteligente"
              :indice="`chamada_inteligente_${inteligente[0].id}`"
              @atualizarMessage="editarChamadaTitulo($event, inteligente[0])"
            />
          </div>
          <button
            data-tourTarget="btn-salvar-chamada-inteligente-fluxo-message"
            class="btn dk-badge-msg" style="width: 258px;margin-top: 8px;"
            @click="editarChamadaTitulo(inteligente); editarChamada()"
          >Salvar Chamada
          </button>

        </div>

      </div>
    </div>
    <ModalTypeReponse
      v-model="isCampoRequired"
      title="Configurações da resposta do usuário"
      @isRiquredField="isCampoRequired = $event"
      @submit="handleFluxoEXTSubmit($event)"
    />
    <ModalConfirmation
      title="Confirmação de exclusão de fluxo de chat"
      @okDeleteFluxoChat="excluirMensagem(formDeleteModal.index, formDeleteModal.nameArray, formDeleteModal.dataMessage)"
    >
      <template #content-message>
        Tem certeza de que deseja <strong>excluir</strong> o fluxo de chat?
      </template>
    </ModalConfirmation>
    <div class="fixed-button bg-light">
      <button
        class="btn btn-primary"
        @click="salvarFluxo()"
      >
        Salvar Fluxo
      </button>
    </div>
  </div>
</template>
<script>
import VSelect from 'vue-select'
import {
  BButton, BFormGroup, BFormInput, BModal, VBModal, BListGroup,
  BListGroupItem, BFormCheckboxGroup, BFormCheckbox, BFormRadioGroup,
  BInputGroupAppend, BInputGroupPrepend, BRow, BCol, BInputGroup,
  BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.br'
import Ripple from 'vue-ripple-directive'
import { useApi } from '@/composables/useApi'
import Info from '@/views/App/Chat/Info.vue'
import { Vue2TinymceEditor } from 'vue2-tinymce-editor'
import ModalTypeReponse from '@/components/chatBooster/ModalTypeResponse.vue'
import ModalConfirmation from '@/components/ModalConfirmation.vue'

const apiBack = useApi()
export default {
  components: {
    BButton,
    BFormGroup,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BModal,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormRadioGroup,
    BDropdown,
    BDropdownItem,
    BInputGroupAppend,
    BInputGroupPrepend,
    BRow,
    BCol,
    BInputGroup,
    Info,
    Vue2TinymceEditor,
    ModalTypeReponse,
    VSelect,
    ModalConfirmation,
    Cleave,

  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      formDeleteModal: {
        index: null,
        nameArray: null,
        dataMessage: null,
      },
      fluxoModificado: [],
      inicialModificado: [],
      showDropArea: false,
      isCampoRequired: {},
      nomeArray: 'inicial',
      mensagemEditada: '',
      chatId: this.$route.query.id_chat,
      mensagensDeletadas: [],
      mensagensIniDeletadas: [],
      name: '',
      nameState: null,
      tipoSelecionado: [],
      typesMensagem: [],
      inicialSeq: 1,
      fluxoSeq: 1,
      dadoschat: [],
      value: [],
      inicial: [],
      fluxo: [],
      variaveis: [],
      inteligente: [],
      selectedIdini: null,
      selectedId: null,
    }
  },
  mounted() {
    this.chatInicial()
    this.chatFluxo()
    this.chatInteligente()
    this.Listavariaveis()
    this.chat()
    this.types()
    this.inicial.forEach((mensagem, index) => {
      const emailHeaderConfig = {
        selector: `.tinymce-heading_${index}`,
        menubar: false,
        inline: true,
        paste_as_text: true,
        plugins: [
          'lists',
          'paste',
          'autolink',
          'emoticons',
        ],
        toolbar: 'undo redo | bold italic underline | emoticons',
        valid_elements: 'strong,em,span[style],a[href]',
        valid_styles: {
          '*': 'font-size,font-family,color,text-decoration,text-align',
        },
      }
      tinymce.init(emailHeaderConfig)
    })
  },

  methods: {

    async salvarFluxo() {
      const fluxosModificado = this.fluxoModificado
      const fluxos = this.fluxo
      const deleteMensa = this.mensagensDeletadas
      const deleteMensaIni = this.mensagensIniDeletadas
      const menInicial = this.inicial
      const menInicialModificado = this.inicialModificado
      for (const objeto of menInicialModificado) {
        const foundItem = menInicial.find(item => item.id === objeto.id)
        if (foundItem) {
          foundItem.message = objeto.message
        }
      }
      for (const objeto of fluxosModificado) {
        const foundItem = fluxos.find(item => item.id === objeto.id)
        if (foundItem) {
          foundItem.message = objeto.message
        }
      }
      const fluxosTratados = fluxos.map(objeto => {
        // Verifique se o campo options está presente e é um array de objetos
        if (objeto.options && Array.isArray(objeto.options)) {
          // Converta o campo options para uma representação JSON
          objeto.options = JSON.stringify(objeto.options)
        }
        return objeto
      })
      fluxosTratados.forEach((msg, index) => {
        msg.sequencia = index + 1
      })
      fluxosTratados.forEach(elemento => {
        if (typeof elemento.id === 'string' && elemento.id.startsWith('n')) {
          elemento.id = null
        }
      })
      menInicial.forEach((msg, index) => {
        msg.sequencia = index + 1
      })
      menInicial.forEach(elemento => {
        if (typeof elemento.id === 'string' && elemento.id.startsWith('n')) {
          elemento.id = null
        }
      })
      await apiBack.post(`/updateFluxo/${this.chatId}`, {
        fluxosTratados,
        deleteMensa,
        menInicial,
        deleteMensaIni,
      })
        .then(() => {
          this.chatFluxo()
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
        })
        .catch(err => console.log(err))
    },
    async atualizarMessageFluxo(event, dataMessage) {
      const mensagemAtu = event
      if (dataMessage.nomeArray === 'inicial') {
        const foundItem = this.inicialModificado.find(item => item.id === dataMessage.id)

        if (foundItem) {
          foundItem.message = mensagemAtu
          this.inicialModificado = [...this.inicialModificado]
        }
      } else {
        const foundItem = this.fluxoModificado.find(item => item.id === dataMessage.id)
        if (foundItem) {
          foundItem.message = mensagemAtu
          this.fluxoModificado = [...this.fluxoModificado]
        }
      }
    },
    async atualizaIdtype(mensagem) {

      // await apiBack.put('/id_type/', {
      //   id_type: mensagem.id_type,
      //   id: mensagem.id,
      // })
      //   .then(() => {
      //     this.chatFluxo()
      //   })
      //   .catch(err => console.error(err))
    },
    async chat() {
      await apiBack.get(`/idChat/${this.chatId}`)
        .then(data => {
          this.dadoschat = data.data
        })
        .catch(err => console.error(err))
    },
    async editarChamada() {
      await apiBack.put(`/chamadaInteligente/${this.chatId}`, {
        time: this.inteligente[0].time,
        status: this.inteligente[0].status,
      })
        .then(() => {
          this.chatInteligente()
        })
        .catch(err => console.error(err))
    },
    async editarChamadaTitulo(event, inteligente) {
      await apiBack.put(`/chamadaInteligenteTitulo/${inteligente.id}`, {
        titulo_inteligente: event,
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
        })
        .catch(err => console.error(err))
    },
    async chatInteligente() {
      await apiBack.get(`/chamadaInteligente/${this.chatId}`)
        .then(response => {
          this.inteligente = response.data
        })
        .catch(err => console.error(err))
    },
    async excluirMensagem(index, arrayName, mensagem) {
      if (arrayName === 'inicial') {
        this.inicial.splice(index, 1)
        this.ordenarMensagens(arrayName)
        console.log('MENSAGEM QUE FOI DELETADA', mensagem)
        this.mensagensIniDeletadas.push({
          id: mensagem.id,
        })
      }
      if (arrayName === 'fluxo') {
        this.fluxo.splice(index, 1)
        this.ordenarMensagens(arrayName)
        console.log('ID MENSAGEM QUE FOI DELETADA', mensagem.id)
        this.mensagensDeletadas.push({
          id: mensagem.id,
          id_ext: mensagem.id_ext,
        })
      }
    },
    async types() {
      await apiBack.get('/type')
        .then(response => {
          this.typesMensagem = response.data
        })
        .catch(err => console.error(err))
    },
    async chatInicial() {
      this.inicial = []
      this.inicialModificado = []
      await apiBack.get(`/chatInicialID/${this.chatId}`)
        .then(response => {
          this.inicial = response.data.map(item => ({ ...item }))
          this.inicialModificado = response.data.map(item => ({ ...item }))
        })
        .catch(err => console.error(err))
    },
    async chatFluxo() {
      this.fluxo = []
      this.fluxoModificado = []
      try {
        const response = await apiBack.get(`/chatFluxoID/${this.chatId}`)
        for (const f of response.data) {
          const optionsParse = f
          if (f.options && f.options[0] !== 'null') {
            optionsParse.options = JSON.parse(f.options)
            optionsParse.tags = f.tags ? f.tags.split(',') : []
          }

          this.fluxo.push(optionsParse)
          this.fluxoModificado.push({ ...optionsParse }) // Copiar o objeto usando spread operator
        }
      } catch (err) {
        console.error(err)
      }
    },
    // MODAL
    openModal() {
      this.$refs['my-modal'].show()
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },
    resetModal() {
      this.name = ''
      this.nameState = null
    },
    async handleFluxoEXTSubmit(data) {
      console.log('Mensagem atualizada', data)
      console.log('Variaveis', this.variaveis)
      this.variaveis.forEach(item => {
        if (item.id === data.id_ext) {
          item.label = data.label
        }
      })
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      // Push the name to submitted names
      this.submittedNames.push(this.name)
      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn')
      })
    },
    async adicionarMensagem(arrayName, type) {
      if (type === '0' && arrayName === 'inicial') {
        this[arrayName].push({
          id: `n${this[arrayName].length}${1}`,
          sequencia: this[arrayName].length + 1,
          message: '',
        })
        this.inicialModificado.push({
          id: `n${this[arrayName].length}${1}`,
          sequencia: this[arrayName].length + 1,
          message: '',
        })
      }
      if (type === '1') {
        this[arrayName].push({
          id: `n${this[arrayName].length}${1}`,
          message: '',
          sequencia: this[arrayName].length + 1,
          type: 1,
          id_type: 5,
          options: null,
          id_ext: '',
          label: 'Sem Nome',
          obrigatorio: 0,
          startGPT: 0,
          whatsApp: 0,
          mensagem_whatsApp: '',
          horario_whatsApp: 0,
          horas_inicio_whatsApp: '',
          horas_finais_whatsApp: '',
          seg_whatsApp: 0,
          ter_whatsApp: 0,
          qua_whatsApp: 0,
          qui_whatsApp: 0,
          sex_whatsApp: 0,
          sab_whatsApp: 0,
          dom_whatsApp: 0,
          auto_whatsApp: 0,
          valor_whatsApp: null,
          type_ext: 'Texto',
          idField: 'Texto',
          typeField: 'string',
          phField: 'Escreva um texto',
          autocomplete: 'false',
        })
        this.fluxoModificado.push({
          id: `n${this[arrayName].length}${1}`,
          message: '',
          sequencia: this[arrayName].length + 1,
          type: 1,
          id_type: 5,
          options: null,
          id_ext: '',
          label: 'Sem Nome',
          obrigatorio: 0,
          startGPT: 0,
          whatsApp: 0,
          mensagem_whatsApp: '',
          horario_whatsApp: 0,
          horas_inicio_whatsApp: '',
          horas_finais_whatsApp: '',
          seg_whatsApp: 0,
          ter_whatsApp: 0,
          qua_whatsApp: 0,
          qui_whatsApp: 0,
          sex_whatsApp: 0,
          sab_whatsApp: 0,
          dom_whatsApp: 0,
          auto_whatsApp: 0,
          valor_whatsApp: null,
          type_ext: 'Texto',
          idField: 'Texto',
          typeField: 'string',
          phField: 'Escreva um texto',
          autocomplete: 'false',
        })
      }
      if (type === '2') {
        this[arrayName].push({
          id: `n${this[arrayName].length}${1}`,
          message: '',
          sequencia: this[arrayName].length + 1,
          options: [{ name: 'Opçao 1', whatsApp: '' }, { name: 'Opçao 2', whatsApp: '' }],
          tags: ['Opçao 1', 'Opçao 2', 'Opçao 3'],
          type: 2,
          id_type: 0,
          id_ext: '',
          label: 'Sem nome',
          obrigatorio: 0,
          startGPT: 0,
          whatsApp: 0,
          mensagem_whatsApp: '',
          horario_whatsApp: 0,
          horas_inicio_whatsApp: '',
          horas_finais_whatsApp: '',
          seg_whatsApp: 0,
          ter_whatsApp: 0,
          qua_whatsApp: 0,
          qui_whatsApp: 0,
          sex_whatsApp: 0,
          sab_whatsApp: 0,
          dom_whatsApp: 0,
          auto_whatsApp: 0,
          type_ext: 'Texto',
          idField: '',
          typeField: '',
          phField: ' ',
          autocomplete: '',
        })
        this.fluxoModificado.push({
          id: `n${this[arrayName].length}${1}`,
          message: '',
          sequencia: this[arrayName].length + 1,
          options: [{ name: 'Opçao 1', whatsApp: '' }, { name: 'Opçao 2', whatsApp: '' }],
          tags: ['Opçao 1', 'Opçao 2', 'Opçao 3'],
          type: 2,
          id_type: 0,
          id_ext: '',
          label: 'Sem nome',
          obrigatorio: 0,
          startGPT: 0,
          whatsApp: 0,
          mensagem_whatsApp: '',
          horario_whatsApp: 0,
          horas_inicio_whatsApp: '',
          horas_finais_whatsApp: '',
          seg_whatsApp: 0,
          ter_whatsApp: 0,
          qua_whatsApp: 0,
          qui_whatsApp: 0,
          sex_whatsApp: 0,
          sab_whatsApp: 0,
          dom_whatsApp: 0,
          auto_whatsApp: 0,
          type_ext: 'Texto',
          idField: '',
          typeField: '',
          phField: ' ',
          autocomplete: '',
        })
      }
      if (type === '3') {
        this[arrayName].push({
          id: `n${this[arrayName].length}${1}`,
          message: '',
          sequencia: this[arrayName].length + 1,
          options: null,
          type: 3,
          id_type: 2,
          id_ext: '',
          label: 'WhatsApp',
          obrigatorio: 0,
          startGPT: 0,
          whatsApp: 0,
          mensagem_whatsApp: 'Ola ,tudo bem?',
          horario_whatsApp: 1,
          horas_inicio_whatsApp: '',
          horas_finais_whatsApp: '',
          seg_whatsApp: 0,
          ter_whatsApp: 0,
          qua_whatsApp: 0,
          qui_whatsApp: 0,
          sex_whatsApp: 0,
          sab_whatsApp: 0,
          dom_whatsApp: 0,
          auto_whatsApp: 0,
          type_ext: 'phone',
          idField: 'phone',
          typeField: 'phone',
          phField: 'Seu whatsApp por favor',
          autocomplete: 'true',
        })
        this.fluxoModificado.push({
          id: `n${this[arrayName].length}${1}`,
          message: '',
          sequencia: this[arrayName].length + 1,
          options: null,
          type: 3,
          id_type: 2,
          id_ext: '',
          label: 'WhatsApp',
          obrigatorio: 0,
          startGPT: 0,
          whatsApp: 0,
          mensagem_whatsApp: 'Ola ,tudo bem?',
          horario_whatsApp: 1,
          horas_inicio_whatsApp: '',
          horas_finais_whatsApp: '',
          seg_whatsApp: 0,
          ter_whatsApp: 0,
          qua_whatsApp: 0,
          qui_whatsApp: 0,
          sex_whatsApp: 0,
          sab_whatsApp: 0,
          dom_whatsApp: 0,
          auto_whatsApp: 0,
          type_ext: 'phone',
          idField: 'phone',
          typeField: 'phone',
          phField: 'Seu whatsApp por favor',
          autocomplete: 'true',
        })
      }
      if (type === '0' && arrayName === 'fluxo') {
        this[arrayName].push({
          id: `n${this[arrayName].length}${1}`,
          message: '',
          sequencia: this[arrayName].length + 1,
          type: 0,
          id_type: 0,
          options: null,
          id_ext: null,
          label: null,
          obrigatorio: null,
          startGPT: 0,
          whatsApp: null,
          type_ext: null,
          idField: '',
          typeField: '',
          phField: '',
          autocomplete: '',
        })
        this.fluxoModificado.push({
          id: `n${this.fluxoModificado.length}${1}`,
          message: '',
          sequencia: this[arrayName].length + 1,
          type: 0,
          id_type: 0,
          options: null,
          id_ext: null,
          label: null,
          obrigatorio: null,
          startGPT: 0,
          whatsApp: null,
          type_ext: null,
          idField: '',
          typeField: '',
          phField: '',
          autocomplete: '',
        })
      }
    },
    dragStart(index, arrayName) {
      console.log('Entrei dragstart')
      this.draggedIndex = {
        index,
        arrayName,
      }
    },
    dragOver(index, arrayName) {
      let newIndex = null
      if (this.draggedIndex.arrayName === arrayName) {
        // Arrastando dentro do mesmo array
        if (this.draggedIndex.index !== index) {
          const mensagemArrastada = this[arrayName][this.draggedIndex.index]
          this[arrayName].splice(this.draggedIndex.index, 1)
          this[arrayName].splice(index, 0, mensagemArrastada)
          this.draggedIndex.index = index
          this.odernarMessagenMesmoArray()
          // this.ordenarMensagens(arrayName);
        }
      } else {
        // Arrastando de um array para outro
        const mensagemArrastada = this[this.draggedIndex.arrayName][this.draggedIndex.index]
        this[this.draggedIndex.arrayName].splice(this.draggedIndex.index, 1)
        if (index >= this[arrayName].length) {
          // Adiciona a mensagem ao final do array
          this[arrayName].push(mensagemArrastada)
        } else {
          // Adiciona a mensagem no índice correto no array
          newIndex = this[arrayName].length + 1
          mensagemArrastada.sequencia = newIndex
          const newMessagem = {
            ...mensagemArrastada,
            type: 0,
            id_type: null,
            id: null,
            idField: null,
            typeField: null,
            phField: null,
            autocomplete: null,
          }
          this[arrayName].splice(index, 0, newMessagem)
        }
        this.draggedIndex = {
          index,
          arrayName,
        }
        this.ordenarMensagens(arrayName)
      }
    },
    dragEnd(indiceAtual, arrayName) {
      console.log('ENTREI NO DRAGEND')
      // Se houver uma mensagem arrastada anteriormente
      if (this.draggedIndex !== null) {
        // Obtém a mensagem arrastada
        const draggedMsg = this[this.draggedIndex.arrayName][this.draggedIndex.index]
        if (arrayName === 'fluxo') {
          this.fluxoModificado.forEach((msg, index) => {
            msg.sequencia = index + 1
          })
        }
        if (arrayName === 'inicial') {
          this.inicialModificado.forEach((msg, index) => {
            msg.sequencia = index + 1
          })
        }
        // Obtém o novo índice da mensagem arrastada no array atual
        const newIndex = this[arrayName].indexOf(draggedMsg)
        // Se a mensagem foi movida para outro array
        if (arrayName !== this.draggedIndex.arrayName) {
          // Atualiza o valor de draggedIndex para o novo array
          this.draggedIndex = {
            index: newIndex,
            arrayName,
          }
          this.ordenarMensagens(arrayName)
          this.inicial.forEach(mensagem => {
            this.atualizaMensagemInicial(mensagem)
          })
          this.fluxo.forEach(mensagem => {
            this.atualizaMensagemFluxo(mensagem)
          })
        } else {
          // Atualiza apenas o índice da mensagem arrastada no mesmo array
          this.draggedIndex.index = newIndex
        }
      }
    },
    async atualizaMensagemInicial(mensagem) {
      await apiBack.put(`/chatMensagemInicial/${mensagem.id}`, {
        sequencia: mensagem.sequencia,
        message: mensagem.message,
      })
        .then(() => {
          this.chatInicial()
        })
        .catch(err => console.error(err))
    },
    async atualizaMensagemFluxo(mensagem) {
      console.log('mensagem')
      await apiBack.put(`/chatMensagemFluxo/${mensagem.id}`, {
        sequencia: mensagem.sequencia,
        message: mensagem.message,
      })
        .then(() => {
          this.chatFluxo()
        })
        .catch(err => console.error(err))
    },
    async atualizarCallAction(message) {
      await apiBack.put('/updateCallAction/', {
        callToAction: message,
        id: this.chatId,
      })
        .then(() => console.log('atualizaMensagemFluxo'))
        .catch(err => console.error(err))
    },
    odernarMessagenMesmoArray() {
      this[this.draggedIndex.arrayName][this.draggedIndex.index]
    },
    ordenarMensagens() {
      // Obtém a lista de mensagens correspondente ao nome do array
      const listaMensagens = this.inicial
      const listaMensagemFluxo = this.fluxo
      // Ordena as mensagens com base no valor da sequência
      listaMensagens.sort((a, b) => a.sequencia - b.sequencia)
      listaMensagemFluxo.sort((a, b) => a.sequencia - b.sequencia)
      // Atualiza o valor da sequência para cada mensagem, de acordo com a nova ordem
      listaMensagens.forEach((mensagem, index) => {
        mensagem.sequencia = index + 1
      })
      listaMensagemFluxo.forEach((mensagem, index) => {
        mensagem.sequencia = index + 1
      })
    },
    async atualizaOpcao(mensagem) {
      // Criar um novo array de opções com base nas tags existentes
      const novasOpcoes = mensagem.tags.map(tag => {
        const existingOption = mensagem.options.find(option => option.name === tag)
        if (existingOption) {
          return existingOption
        }
        return {
          name: tag,
          whatsApp: '',
        }
      })

      // Atualizar o segundo array com as novas opções
      console.log(novasOpcoes)
      for (const f of this.fluxo) {
        if (f.id === mensagem.id) {
          f.options = novasOpcoes
        }
      }
    },
    async Listavariaveis() {
      await apiBack.get(`/getFluxoEXTByIdFluxo/${this.chatId}`)
        .then(data => {
          this.variaveis = JSON.parse(JSON.stringify(data.data))
        })
        .catch(err => console.error(err))
    },
    updateArrayVariaveis(varSelected) {
      console.log('ATUALIZAR VARIAVEIS', this.variaveis.filter(variavel => variavel.id === varSelected.id))
      this.variaveis.forEach((variavel, index) => {
        if (variavel.id === varSelected.id) {
          this.variaveis[index].label = this.variaveis[index].label
        }
      })
    },
  },
}
</script>

<style scoped>
.card {
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 12px;
  padding: 12px;
  margin: 12px 0;
  background: #111827 !important;
  box-shadow: 0 6px 22px rgba(0, 0, 0, 0.28);
}

.input-group-text {
  background: #162232 !important;
  border-color: rgba(255, 255, 255, 0.12) !important;
  color: #c5d5e8 !important;
}

.mover {
  cursor: move;
}

.dk-badge-msg {
  background: rgba(232, 106, 16, 0.18) !important;
  color: #ffbe87 !important;
  border: 1px solid rgba(232, 106, 16, 0.35) !important;
  font-weight: 600;
  font-size: 0.8rem;
  border-radius: 6px;
}

.dragging {
  border: 2px dashed #E86A10;
  opacity: 0.78;
}

.form-control,
select.form-control,
input[type='text'],
input[type='time'] {
  background: #0f1e30 !important;
  border: 1px solid rgba(255, 255, 255, 0.14) !important;
  color: #e2e8f0 !important;
}

.form-control::placeholder,
input::placeholder {
  color: rgba(255, 255, 255, 0.35) !important;
}

.form-control:focus,
input:focus,
select:focus {
  border-color: #E86A10 !important;
  box-shadow: 0 0 0 3px rgba(232, 106, 16, 0.14) !important;
}

.btn-outline-dark {
  border-color: rgba(255, 255, 255, 0.2) !important;
  color: rgba(255, 255, 255, 0.75) !important;
  background: rgba(255, 255, 255, 0.03) !important;
}

.btn-outline-dark:hover {
  border-color: rgba(193, 43, 43, 0.55) !important;
  color: #ff9a9a !important;
  background: rgba(193, 43, 43, 0.14) !important;
}

.btn-outline-secondary {
  border-color: rgba(255, 255, 255, 0.2) !important;
  color: rgba(255, 255, 255, 0.72) !important;
  background: rgba(255, 255, 255, 0.03) !important;
}

.btn-outline-secondary:hover {
  border-color: rgba(232, 106, 16, 0.45) !important;
  color: #E86A10 !important;
  background: rgba(232, 106, 16, 0.12) !important;
}

.dropdown-item:hover {
  background-color: rgba(232, 106, 16, 0.12);
  color: #E86A10 !important;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.fixed-button {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 999;
  background: transparent !important;
}

.fixed-button .btn-primary {
  background: linear-gradient(135deg, #E86A10, #F5B935) !important;
  border: 1px solid rgba(232, 106, 16, 0.5) !important;
  color: #fff !important;
  font-weight: 700;
  border-radius: 10px;
  box-shadow: 0 8px 20px rgba(232, 106, 16, 0.35);
  padding: 10px 16px;
}

.fixed-button .btn-primary:hover {
  filter: brightness(1.05);
}

.alou {
  display: flex;
  flex-wrap: wrap;
}

.form-check {
  flex-basis: 10%;
}

.drop-area {
  display: none;
  background-color: rgba(255, 255, 255, 0.03);
  border: 1px dashed rgba(232, 106, 16, 0.45);
  height: 84px;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  margin-bottom: 8px;
}

.drop-text {
  text-align: center;
  color: rgba(255, 255, 255, 0.55);
}

.mensagem.drag-over .drop-area {
  display: flex;
}
</style>
